import { Card, CardHeader, CardPreview, mergeClasses, Text } from "@fluentui/react-components";
import IFolderCardProps from "./IFolderCardProps";
import styles from './FolderCard.module.scss';
import useStyleUtils from "../../utilities/styles";

export default function FolderCard(props: IFolderCardProps) {   
    const folder = props.folder;

    const handleFolderClick = () => props.onClick(props.folder.id);
    const style = useStyleUtils();

    const orientation = folder.logoUri ? 'horizontal' : 'vertical';

    const cardStyles = mergeClasses(styles.card, style.mb3, style.dFlex, style.justifyContentCenter);

    const headerTextStyle = mergeClasses(
        style.dInlineBlock,
        style.w100,
        !folder.logoUri ? styles.noImage : styles.withImage
    );

    return (
        <Card onClick={handleFolderClick} className={cardStyles} orientation={orientation}>
            {
                folder.logoUri &&
                <CardPreview>
                    <img src={folder.logoUri!} alt={folder.name} className={styles.logo} />
                </CardPreview>
            }
            <CardHeader
                header={<Text weight="semibold" size={400} className={headerTextStyle}>{folder.name}</Text>}
                className={styles.header}
                />
        </Card>
    );
}